<template>
  <div
    v-if="
      $trial() &&
        !$subscription() &&
        [
          constants.ROLE_ADMIN_PAYEUR,
          constants.ROLE_ADMIN_ENTREPRISE,
        ].includes(role)
    "
  >
    <p>
      Il vous reste {{ dayBeforeTrialEnd }} jour<span
        v-if="dayBeforeTrialEnd > 1"
      >s</span>
      avant la fin de votre période d'essai.
    </p>
    <p>
      Vous pouvez faire évoluer votre offre
      <router-link
        :to="{ name: 'Subscriptionchoice' }"
        class="text-pink-600 underline cursor-pointer"
      >
        ici
      </router-link>
    </p>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import Constants from '../constants';

export default {
  name: 'TrialPeriodMessage',

  data() {
    return {
      constants: Constants
    };
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
      structure: 'auth/structure',
      role: 'auth/role',
    }),

    dayBeforeTrialEnd() {
      return this.structure.days_before_trial_end;
    },
  }
};
</script>